import { App } from 'vue'
import SocialSecurityInput from './LpSocialSecurityInput.vue'

SocialSecurityInput.install = (Vue: App) => {
  Vue.component(SocialSecurityInput.name, SocialSecurityInput)
}

export default SocialSecurityInput
